import React from 'react';
import { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";

import logoNovo from '../../assets/images/logoNovo.png';
import bemVindo from '../../assets/images/Bem-vindo3.png';
import { SweetAlertSuccess, SweetAlertError, SweetAlertConfirm } from '../../components/sweetAlert/swetAlert.jsx';
import apiAdm from '../../services/apiAdm';

function Login() {
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');

    const navigate = useNavigate();

    // return <>
    //     <div className="main-wrapper">
    //         <div className="page-wrapper full-page">
    //             <div className="page-content d-flex align-items-center justify-content-center">
    //                 <div className="row w-100 mx-0 auth-page">
    //                     <div className="col-md-12 col-xl-9 mx-auto">

    //                         <div className="card">
    //                             <div className="row">
    //                                 <div className="col-md-6 pe-md-0">
    //                                     <img src={bemVindo} width={480} height={500} />
    //                                 </div>
    //                                 <div className="col-md-6 ps-md-0">
    //                                     <div className="auth-form-wrapper px-4 py-5">
    //                                         <div className="row">
    //                                             <span className="img-container">
    //                                                 <img src={logoNovo} style={{marginLeft: 130}} width={150} height={45} />
    //                                             </span>
    //                                         </div>
    //                                         <br/><br></br>
    //                                         <div className="row">
    //                                             <a href="#" className="noble-ui-logo d-block mb-2">Acessar o sistema</a>
    //                                             <form className="forms-sample">
    //                                                 <div className="mb-3">
    //                                                     <label for="userEmail" className="form-label">e-mail</label>
    //                                                     <input type="text" className="form-control" onChange={(e) => setEmail(e.target.value)} value={email} />
    //                                                 </div>
    //                                                 <div className="mb-3">
    //                                                     <label for="userPassword" className="form-label">Senha</label>
    //                                                     <input type="password" className="form-control" onChange={(e) => setSenha(e.target.value)} value={senha} />

    //                                                 </div>
    //                                                 <br />
    //                                                 <div>
    //                                                     <button onClick={entrar} className="btn btn-primary w-100 text-white" type="button">Entrar</button>
    //                                                 </div>
    //                                                 <Link to="/esqueciSenha" className="nav-link d-block mt-3 text-muted">Esqueci minha senha</Link>
    //                                             </form>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //             </div>
    //         </div>
    //     </div>

    // </>;

 return <>

    <div className="container-fluid vh-100">
      <div className="row h-100">
        {/* Lado Esquerdo - Imagem */}
        <div className="col-6 p-0 h-100 d-flex">
          <img
            src={bemVindo}
            alt="Bem vindo"
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
        </div>

        {/* Lado Direito - Login */}
        <div className="col-6 d-flex align-items-center justify-content-center">
          <div style={{ width: "100%", maxWidth: 400 }}>
            {/* Logo */}
            <div className="text-center mb-4">
              <img src={logoNovo} alt="Logo" width={160} />
            </div>

            <h3 className="text-center mb-4">Acessar o sistema</h3>

            <form>
              <div className="mb-3">
                <label className="form-label">E-mail</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Senha</label>
                <input
                  type="password"
                  className="form-control"
                  onChange={(e) => setSenha(e.target.value)}
                  value={senha}
                />
              </div>

              <button
                type="button"
                onClick={entrar}
                className="btn btn-primary w-100"
              >
                Entrar
              </button>

              <div className="text-center mt-3">
                <Link to="/esqueciSenha">Esqueci minha senha</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>


</>;

    function entrar() {

        if (email == '') {
            SweetAlertError({ texto: 'Falta informar o e-mail.' });
            return;
        };
        if (senha == '') {
            SweetAlertError({ texto: 'Falta informar a senha.' });
            return;
        };
        //Temporário
        if (email == '1') {
            setEmail('genilson@kiron.net.br');
            setSenha('kiron123');
        }
        const json = {
            email: email,
            senha: senha
        };

        apiAdm.post('/usuario/authenticate', json)
            .then((resp) => {
                // setLogado(true);
                localStorage.setItem('logado', 'S');
                localStorage.setItem('token', resp.data.token);
                localStorage.setItem('idUsuario',resp.data.usuario.data.id);
                localStorage.setItem('nomeUsuario',resp.data.usuario.data.nome);
                localStorage.setItem('emailUsuario',resp.data.usuario.data.login);
                localStorage.setItem('idEmpresa', resp.data.usuario.permissoes[0].idEntidade);
                localStorage.setItem('nomeEmpresa', resp.data.usuario.permissoes[0].nome);
                localStorage.setItem('cnpjEmpresa', resp.data.usuario.permissoes[0].cnpj);
                localStorage.setItem('idGrupo', resp.data.usuario.permissoes[0].idGrupo);
                localStorage.setItem('cUF', resp.data.usuario.permissoes[0].cUF);
                localStorage.setItem('certSenha', resp.data.usuario.permissoes[0].certSenha);
                localStorage.setItem('nsuNFe', resp.data.usuario.permissoes[0].nsuNFe);
                localStorage.setItem('nsuCTe', resp.data.usuario.permissoes[0].nsuCTe);
                localStorage.setItem('empresas', JSON.stringify(resp.data.usuario.permissoes));
                localStorage.setItem('idDefaultEmpresa',0);
                
                if (resp.data.usuario.permissoes.length > 1) {
                    navigate("/trocar");
                    window.location.reload(true);
                } else {
                    navigate("/dashboard");
                    window.location.reload(true);
                };
            })
            .catch((erro) => {
                localStorage.setItem('logado', 'N');
                console.log(erro);
                SweetAlertError({ texto: 'E-mail ou senha incorreto.' });
                return;
            });

    };

};

export default Login;
